import { useForm } from 'react-hook-form';

export interface LoginForm {
  email: string;
  password: string;
}

export const useLoginForm = () => {
  const { register, handleSubmit, formState: { errors } } = useForm<LoginForm>();

  const email = register('email', {
    required: 'El email es requerido.',
    pattern: {
      value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      message: 'El email ingresado tiene un formato incorrecto.',
    },
  });

  const password = register('password', {
    required: 'La contraseña es requerida.',
  });

  return {
    controls: {
      email,
      password,
    },
    errors,
    handleSubmit,
  }
};
